import AXIOS from "@/libs/axios"

type NewSubscriber = {
  email: string,
  name: string,
  status: string,
  lists: number[]
}

type APIResponse<T> = {
  data?: T
  message?: string
}

export interface Subscriber {
  data: SubscriberData;
}

export interface SubscriberData {
  id: number;
  created_at: string;
  updated_at: string;
  uuid: string;
  email: string;
  name: string;
  attribs: Attribs;
  status: 'enabled' | 'disabled';
  lists: number[];
}

export interface Attribs {
  city: string;
  projects: number;
  stack: Stack;
}

export interface Stack {
  languages: string[];
}


export const addNewSubscriber = async (payload: NewSubscriber): Promise<SubscriberData> => {
  const res = await AXIOS.post(`https://test-entities-api.limolink.net/api/listmonk/subscribers`, payload)
  return res.data
}